import {IReplayNextPlayerInteraction, IWalkOfShameData} from "./IWalkOfShameData";
import {WalkOfShameDataParser} from "./WalkOfShameDataParser";
import {WalkOfShame} from "../../WalkOfShame";
import {WalkOfShameGameMode} from "../WalkOfShameGameMode";

export abstract class WalkOfShameParsedData {

    public readonly mode: string;
    public readonly nextMode: string;
    public readonly reels: string[][];
    public readonly totalWin: number;
    public currentMultiplier: number;
    public readonly overlayWilds: boolean[][] | undefined;
    public readonly scatterPositions: number[];
    public readonly freespinsLeft: number;
    public readonly freespinTriggeredThisSpin: boolean;
    public readonly numberOfFreespinsPlayed: number;
    public readonly replayNextPlayerInteraction: IReplayNextPlayerInteraction | undefined;
    public readonly showTotalWin: boolean;
    public readonly s2SymId: number;

    protected constructor(rawData: IWalkOfShameData, parser: WalkOfShameDataParser) {
        this.mode = rawData.mode;
        this.nextMode = rawData.nextMode;
        this.reels = parser.parseReels(rawData);
        this.totalWin = rawData.accumulatedRoundWin || 0;

        this.overlayWilds = rawData.overlayWilds;
        this.scatterPositions = parser.parseScatterPositions(rawData);

        this.freespinsLeft = rawData.freespinsLeft != null ? rawData.freespinsLeft : 0;
        this.freespinTriggeredThisSpin = rawData.freespinTriggeredThisSpin;
        this.numberOfFreespinsPlayed = rawData.numberOfFreespinsPlayed != null ? rawData.numberOfFreespinsPlayed : 0;
        this.replayNextPlayerInteraction = WalkOfShame.apiPlugin.isReplay ? rawData.nextPlayerInteraction : undefined;
        this.showTotalWin = this.parseShowTotalWin();
        this.s2SymId = this.getS2SymId();
    }

    private static isRespinMode(mode: string): boolean {
        return (mode === WalkOfShameGameMode.RESPIN || mode === WalkOfShameGameMode.SUPER_FREESPIN_RESPIN);
    }

    protected parseShowTotalWin(): boolean {
        return WalkOfShameParsedData.isRespinMode(this.mode) || WalkOfShameParsedData.isRespinMode(this.nextMode) ||
            this.isFreespinMode(this.mode) || this.isFreespinMode(this.nextMode);
    }

    private isFreespinMode(mode: string): boolean {
        return this.freespinTriggeredThisSpin || mode === WalkOfShameGameMode.FREESPIN || mode === WalkOfShameGameMode.SUPER_FREESPIN;
    }

    private getS2SymId(): number {
        for (let symId: number = 1; symId < this.reels[0].length - 2; symId++) {
            if (this.reels[0][symId] === "S2") {
                return (symId - 1);
            }
        }
        return -1;
    }
}